import PropTypes from 'prop-types';

/**
 * @deprecated Pass `onClose: () => void` directly as a prop instead. See docs/mantine-modals.md.
 */
export const ModalFrameworkMethodsPropType = PropTypes.shape({
  cancelModal: PropTypes.func,
  closeModal: PropTypes.func,
});
